module.exports = __webpack_public_path__ + "img/LOGO.bd753d17.png";